import { resolveUtilitySourceToolKey } from '@saas-pages/shared/public/registry'
import { calcdeckUtilityRegistry } from '@/shared/utility-registry'

export function resolveCalcdeckSourceToolKey(pathname: string): string | undefined {
  return resolveUtilitySourceToolKey(calcdeckUtilityRegistry, pathname)
}
